/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { object } from "prop-types";

import Organism5 from "../../organisms/organism-5";

import "./four-stories-four-images.m.css";
import CarouselSlider from "../../molecules/carousel-slider";

class FourStoriesFourImages extends React.Component {
  constructor(props) {
    super(props);
    this.state = { width: null };
  }

  isWidthPresent = () => {
    this.setState({ width });
  };

  componentDidMount() {
    this.isWidthPresent();
  }

  render() {
    const { collection } = this.props;
    const collectionItems = collection.items.length > 0 ? collection.items : [];
    const filteredCollectionItems = collectionItems
      .filter(item => item.type === "collection" && item.items.length > 0)
      .slice(0, 4);
    const organism2Set = filteredCollectionItems.map((item, index) => {
      return <Organism5 collection={item} key={index} headlineLimit={70} />;
    });

    return filteredCollectionItems ? (
      <React.Fragment>
        {this.state.width < 768 &&
          filteredCollectionItems.length >= 4 && (
            <div styleName="carousel-wrapper">
              <CarouselSlider collection={collection} type="collection" />
            </div>
          )}
        {this.state.width > 768 && <div styleName="wrapper">{organism2Set}</div>}
      </React.Fragment>
    ) : null;
  }
}

export default FourStoriesFourImages;

FourStoriesFourImages.propTypes = {
  collection: object
};
